import { render, staticRenderFns } from "./Vantaggi.vue?vue&type=template&id=eb6eae4c"
import script from "./Vantaggi.vue?vue&type=script&lang=js"
export * from "./Vantaggi.vue?vue&type=script&lang=js"
import style0 from "./Vantaggi.vue?vue&type=style&index=0&id=eb6eae4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports